import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EntityService } from '@services/core/entity.service';
import { EditGroupComponent } from './editGroup/editGroup.component';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { pickNamed } from '../named-filter.helper';

@Component({
	selector: 'app-groups',
	templateUrl: './groups.component.html',
	styleUrls: ["./groups.component.css"],
    imports: [CommonModule, NgbTooltipModule, PanelComponent, EditGroupComponent ],
	changeDetection: ChangeDetectionStrategy.Default,
	standalone: true,
})
export class GroupComponent implements OnInit{
    protected groups
    protected group
    private groupsTemp
    protected showEditGroup = false
    private entityService = inject(EntityService)
    private route = inject(ActivatedRoute)
    private destroyRef = inject(DestroyRef)

	ngOnInit(): void {
	    const data = this.route.snapshot.data['groupData']
	    if (!data) return
	    this.groups = data.groups
	    this.groupsTemp = data.groupsTemp
	}

    getGroups(){
        this.group = null
        this.showEditGroup = false
        this.entityService.getGroupsEntities().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.groups = res
                this.groupsTemp = res
            },
            error: (err) => console.error('Error al obtener grupos:', err)
        })
    }

    filterGroups(value: string) {
        if (this.groupsTemp) this.groups = pickNamed(this.groupsTemp, value)
    }

    addGroup(){
        this.group = null
        this.showEditGroup = true
    }

    setEditGroup(group: any){
        this.group = group
    }

    toggleGroup(group: any){
        group.enabled = !group.enabled
        this.entityService.updateGroup(group).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            error: (err) => console.error('Error al actualizar grupo:', err)
        })
    }

    moveUp(i: number) {
        if (i === 0) return
        const item = this.groups[i]
        this.groups[i] = this.groups[i - 1]
        this.groups[i - 1] = item
        this.entityService.updateGroups(this.groups).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            error: (err) => console.error(err)
        })
    }

    moveDown(i: number) {
        if (i === this.groups.length - 1) return
        const item = this.groups[i]
        this.groups[i] = this.groups[i + 1]
        this.groups[i + 1] = item
        this.entityService.updateGroups(this.groups).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            error: (err) => console.error('Error al reordenar grupos:', err)
        })
    }
}
